import axios from 'axios'
import ReasonInterface from '@/models/ReasonInterface'

export default class ReasonService {
  private baseUrl = '/api/v1/reasons'

  public getAll() {
    return axios.get(`${this.baseUrl}/`)
  }

  public getById(id: number) {
    return axios.get(`${this.baseUrl}/${id}`)
  }

  public create(reason: Partial<ReasonInterface>) {
    return axios.post(`${this.baseUrl}/`, reason)
  }

  public update(id: number, reason: Partial<ReasonInterface>) {
    return axios.put(`${this.baseUrl}/${id}`, reason)
  }

  public delete(id: number) {
    return axios.delete(`${this.baseUrl}/${id}`)
  }
}
